'use strict';
angular.module("manageSysXhsgCircuitServiceModule", [
        'manageSysXhsgCreateNewCircuitConfigModule',
        'manageSysXhsgRenewConfigModule'
    ])
    .factory("manageSysXhsgCircuitService", ['$modal', '$q', function($modal, $q) {
        return {
            /**
             * [createNewCircuitConfig 新增编辑线路配置]
             * @param  {[type]} item         [description]
             * @param  {[type]} TenantConfig [description]
             * @return {[type]}              [description]
             */
            createNewCircuitConfig: function(item, TenantConfig) {
                var defer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: "./manageConfig/sysManageMent/xhsgCircuit/manageSysXhsgCircuitService/createNewCircuitConfig_tpl.html",
                    windowClass: 'create-new-circuit-config',
                    backdrop: false,
                    controller: "manageSysXhsgCreateNewCircuitConfigCtrl",
                    resolve: {
                        curItem: function() {
                            return item;
                        },
                        TenantConfig: function(){
                            return TenantConfig;
                        }
                    }
                });
                modalInstance.result.then(function(success) {
                    defer.resolve();
                }, function(error) {});
                return defer.promise;
            },
            /**
             * [renewConfig 续费]
             * @param  {[type]} items [description]
             * @return {[type]}       [description]
             */
            renewConfig: function(items) {
                var defer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: './manageConfig/sysManageMent/xhsgCircuit/manageSysXhsgCircuitService/renewConfig/renewConfig_tpl.html',
                    windowClass: 'renew-config',
                    backdrop: false,
                    controller: 'manageSysXhsgRenewConfigCtrl',
                    resolve: {
                        items: function(){
                            return items;
                        }
                    }
                });
                modalInstance.result.then(function(success) {
                    defer.resolve();
                }, function(error) {});
                return defer.promise;
            }
        };
    }])